// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UzN7z3NiqMsRPcS81w_m{margin-bottom:32px;padding-left:20px}.i1kFYyQK5UU7JBoeq4z1{min-height:unset;padding:16px 20px 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statusBadge": `UzN7z3NiqMsRPcS81w_m`,
	"header": `i1kFYyQK5UU7JBoeq4z1`
};
export default ___CSS_LOADER_EXPORT___;
